// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';

const ErrorPage = () => {
  const { t } = useTranslation();

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('errorPage.title')} />
    </PageContentComponent>
  );
};

export default ErrorPage;
